// extracted by mini-css-extract-plugin
export default {"progresssummary-header":"progresssummary_progresssummary-header__xpMMU"};